import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import env from '@/env';
import { userNavOverridesAtom } from '@/atoms/queries/user';
import { useExploreNavigationItems } from './subNavigation/useExploreNavigationItems';

export const BASE_CLASSIC_EXPLORE_ROUTE = `https://${env.VITE_IQ_DOMAIN}/scout/search`;

export const useExploreNavigationItem = () => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation('navigation');
  const isClassicPlayerScoutXp = useAtomValue(userNavOverridesAtom).playerScout;
  const path = isClassicPlayerScoutXp ? `${BASE_CLASSIC_EXPLORE_ROUTE}/men` : `/${locale}/data-locker`;

  return {
    id: 'explore',
    icon: 'IqScout' as const,
    label: t('crossPlatform.primary.explore'),
    subNav: useExploreNavigationItems(),
    // TODO (EPT-6405: replace this with the new explore landing page)
    path,
  };
};
